import type { ColumnDef } from "@tanstack/react-table";
import type { PayrollRosterField } from "@/payroll/roster/types";
import { formatRosterValue } from "@/payroll/roster/utils";
import { rosterColumnHeader } from "./header";
import { RosterCellValue } from "./roster-cell-value";
import type { ReadOnlyRosterRow } from "./types";

export const ReadOnlyRosterFieldCol = (
  field: PayrollRosterField,
  width: number,
): ColumnDef<ReadOnlyRosterRow, unknown> => ({
  id: `field-${field.key}`,
  header: rosterColumnHeader(field.label),
  enableSorting: false,
  meta: { size: `${width}px` },
  cell: ({ row }) => (
    <RosterCellValue
      value={formatRosterValue(
        row.original.member.field_values[field.key],
        field,
      )}
    />
  ),
});
